export class UiConstants {
    static PasswordInfo: string =
        'Requirements:\n' +
        '\n' +
        '- Minimum length: 8\n' +
        '- Needs a digit (1, 2, 3, ...) \n' +
        '- Needs a lower case (a, b, c, ...)\n' +
        '- Needs an upper case (A, B, C, ...)\n' +
        '- Needs a special character (!, &, _, ...)\n'
    static NoTag = '--- NO TAG ---'
    static MultiTag = '--- MULTIPLE TAGS ---'
}
